import { render, staticRenderFns } from "./InsightsPeriodoBot.vue?vue&type=template&id=0dca3fef&scoped=true"
import script from "./InsightsPeriodoBot.vue?vue&type=script&lang=js"
export * from "./InsightsPeriodoBot.vue?vue&type=script&lang=js"
import style0 from "./InsightsPeriodoBot.vue?vue&type=style&index=0&id=0dca3fef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dca3fef",
  null
  
)

export default component.exports